<script lang="ts">
  import {
    getSwiperPaginationBulletActiveStyle,
    getSwiperPaginationBulletStyle,
    getSwiperPaginationFractionStyle,
    getSwiperPaginationStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    ISwiperPaginationBullet,
    ISwiperPaginationFraction,
    ISwiperPaginationNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { getCurrentDocumentNode, getStore } from "../../context";

  export let node: PartialNode<ISwiperPaginationNode>;
  let nodeStyle: PartialNode<
    ISwiperPaginationBullet | ISwiperPaginationFraction
  >;
  let hidePagination: boolean = false;

  const {
    swiperRealIndex,
    swiperInstance,
    swiperLength,
    captureMode,
    childrenNodeData,
    reactionEventListener: dispatchReactionEvent,
  } = getStore();

  const documentNode = getCurrentDocumentNode();

  function handleBulletClick(e: Event, index: number) {
    $swiperInstance.slideToLoop(index);
    dispatchReactionEvent({
      documentNode,
      element: e.target as HTMLElement,
      node,
      data: {
        nodeId: node.id ?? "",
        nodeName: `${node.name}_${index}`,
        trigger: { type: "ON_CLICK" },
        action: { type: "SLIDE_TO", index },
      },
      // eslint-disable-next-line no-console
    }).catch((e) => console.error(e));
  }

  $: {
    if (node.style) {
      nodeStyle = node.style;
    }
  }

  $: {
    hidePagination = !!$childrenNodeData && $childrenNodeData.length === 1;
  }
</script>

<div
  style={styleToString({
    ...getSwiperPaginationStyle(node),
    ...(hidePagination && {
      visibility: "hidden",
      pointerEvents: "none",
    }),
  })}
>
  {#if nodeStyle.type === "BULLET"}
    {#each Array.from({ length: $captureMode ? 3 : $swiperLength }) as _, index}
      <!-- a11y 이슈로 keydown 도 추가. @see https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/click-events-have-key-events.md -->
      <div
        role="button"
        tabindex="0"
        style={styleToString({
          ...(index === $swiperRealIndex
            ? getSwiperPaginationBulletActiveStyle(nodeStyle)
            : getSwiperPaginationBulletStyle(nodeStyle)),
          ...(hidePagination && { cursor: "default" }),
        })}
        class={index !== $swiperRealIndex
          ? "pagination-bullet"
          : "pagination-bullet active"}
        on:click={(e) => handleBulletClick(e, index)}
        on:keydown={(e) => handleBulletClick(e, index)}
      ></div>
    {/each}
  {:else if nodeStyle.type === "FRACTION"}
    <div
      style={styleToString({
        ...getSwiperPaginationFractionStyle(nodeStyle),
        ...(hidePagination && { cursor: "default" }),
      })}
    >
      <span
        >{$swiperRealIndex === 0 || !!$swiperRealIndex
          ? $swiperRealIndex + 1
          : 0}/{$captureMode ? 3 : $swiperLength}</span
      >
    </div>
  {/if}
</div>

<style>
  .pagination-bullet:not(.active):hover {
    opacity: 0.8;
  }
</style>
